import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ChecklisteFragaAdminDTO, ChecklistGruppAdminDTO } from "./sysadm.checklista.models";

@Injectable({
    providedIn: "root"
})
export class SysdamChecklistaService {
    private readonly apiClient = inject(ApiClientService);

    getAllGrupperWithFragor(): Observable<ChecklistGruppAdminDTO[]> {
        return this.apiClient.get("checklista");
    }

    createChecklisteFraga(fraga: ChecklisteFragaAdminDTO): Observable<ChecklisteFragaAdminDTO> {
        return this.apiClient.post("checklista/create/fraga", fraga);
    }

    createChecklistGrupp(grupp: ChecklistGruppAdminDTO): Observable<ChecklistGruppAdminDTO> {
        return this.apiClient.post("checklista/create/grupp", grupp);
    }

    deleteChecklistGrupp(gruppId: number) {
        return this.apiClient.post(`checklista/${gruppId}/delete`, null);
    }
}
